import { render, staticRenderFns } from "./zxServiceList.vue?vue&type=template&id=19c9a6a0&scoped=true&"
import script from "./zxServiceList.vue?vue&type=script&lang=js&"
export * from "./zxServiceList.vue?vue&type=script&lang=js&"
import style0 from "./zxServiceList.vue?vue&type=style&index=0&id=19c9a6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9a6a0",
  null
  
)

export default component.exports